<template>
  <div class="human-verify" v-loading="loading" element-loading-text="加载中，请稍等...">
    <div v-if="loaded" class="compare-image">
      <div class="new-title">
        <img src="../../../../../../assets/icons/icon_Compared.png" alt="">
        <span>对比图像</span>
      </div>
      <div class="compare-content">
        <div class="image">
          <img :src="cardVerifyInfo.cameraPhotoPath" alt="">
          <div>采集照片</div>
        </div>
        <div v-if="cardVerifyInfo.cameraPhotoPath && cardVerifyInfo.cardPhotoPath" class="compare-num">
          <div class="judge" :class="[cardVerifyInfo.cameraPhotoIsPass ? 'green' : 'red']">
            <img v-if="cardVerifyInfo.cameraPhotoIsPass" src="../../../../../../assets/icons/icon_correct.png" alt="">
            <img v-else src="../../../../../../assets/icons/icon_mistake.png" alt="">
          </div>
          <span>{{ cardVerifyInfo.cameraSimilarity }}%</span>
        </div>
        <div class="image">
          <img :src="cardVerifyInfo.cardPhotoPath" alt="">
          <div>身份证照片</div>
        </div>
        <div v-if="cardVerifyInfo.userPhotoPath && cardVerifyInfo.cardPhotoPath" class="compare-num">
          <div class="judge" :class="[cardVerifyInfo.userPhotoIsPass ? 'green' : 'red']">
            <img v-if="cardVerifyInfo.userPhotoIsPass" src="../../../../../../assets/icons/icon_correct.png" alt="">
            <img v-else src="../../../../../../assets/icons/icon_mistake.png" alt="">
          </div>
          <span>{{ cardVerifyInfo.similarity }}%</span>
        </div>
        <div class="image">
          <img :src="cardVerifyInfo.userPhotoPath" alt="">
          <div>个人照片</div>
        </div>
      </div>
    </div>
    <div v-if="loaded" class="verify-info">
      <div class="new-title">
        <img src="../../../../../../assets/icons/icon_information.png" alt="">
        <span>核对信息</span>
      </div>
      <div class="bottom-check">
        <div class="check-content">
          <div class="line">
            <div class="line-cell">
              <div class="line-cell-name">姓名</div>
              <div v-if="cardVerifyInfo.cardInfo" class="line-cell-value">{{cardVerifyInfo.cardInfo.trueName}}</div>
            </div>
          </div>
          <div class="line">
            <div class="line-cell">
              <div class="line-cell-name">性别</div>
              <div v-if="cardVerifyInfo.cardInfo" class="line-cell-value">{{cardVerifyInfo.cardInfo.gender}}</div>
            </div>
          </div>
          <div class="line">
            <div class="line-cell">
              <div class="line-cell-name">出生年月</div>
              <div v-if="cardVerifyInfo.cardInfo" class="line-cell-value">{{DateFormat(cardVerifyInfo.cardInfo.birthday)}}</div>
            </div>
          </div>
          <div class="line">
            <div class="line-cell">
              <div class="line-cell-name">民族</div>
              <div v-if="cardVerifyInfo.cardInfo" class="line-cell-value">{{cardVerifyInfo.cardInfo.folk}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'portrait',
  data () {
    return {
      loading: false,
      loaded: false,
      cardVerifyInfo: {},
      verifyInfo: {}
    }
  },
  props: {
    studentId: {
      type: String,
      default: ''
    }
  },
  methods: {
    queryStudentDetail () {
      this.$ajax({
        url: '/workspace/manager/enrolling/student/cardVerify/studentBasicInfo',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.studentId
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.cardVerifyInfo = response.data['cardVerifyInfo']
              break
            }
            default: {
              this.$message.error(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
        this.loaded = true
      })
    },
    checkIsPass (name, value) {
      return name === value
    },
    DateFormat (time) {
      if (time) {
        return time.substring(0, 4) + '年' + time.substring(5, 7) + '月' + time.substring(8, 10) + '日'
      } else {
        return ''
      }
    },
    checkDateIsPass (date, value) {
      let newDate = value.replace(/-/g, '')
      let nowDate = date.replace(/-/g, '')
      return newDate === nowDate
    }
  },
  mounted () {
    this.loading = true
    this.queryStudentDetail()
  }
}
</script>

<style scoped lang="scss">
.human-verify {
  height: 482px;
  padding: 20px 110px;
  border-radius: 14px;

  .new-title {
    margin-bottom: 10px;
    color: rgb(51, 51, 51);
    font-size: 14px;
    display: flex;
    align-items: center;
    & > img {
      width: 20px;
      height: 20px;
      margin-right: 6px;
    }
  }
  & > .compare-image {
    width: 100%;
    margin-bottom: 16px;
    & > .new-title {
      margin-bottom: 10px;
      color: rgb(51, 51, 51);
      font-size: 14px;
      display: flex;
      align-items: center;
      & > img {
        width: 20px;
        height: 20px;
        margin-right: 6px;
      }
    }
    & > .compare-content {
      width: 100%;
      height: 172px;
      background-color: rgb(236, 244, 255);
      border-radius: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 100px 10px;
      & > .image {
        width: 150px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        & > img {
          width: 100px;
          height: 128px;
          object-fit: cover;
          margin-bottom: 4px;
          border-radius: 5px;
        }
        & > div {
          color: #666666;
          font-size: 14px;
        }
      }
      & > .compare-num {
        color: #666666;
        font-size: 14px;
        font-weight: 550;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        & > .judge {
          font-size: 24px;
          border-radius: 50%;
          text-align: center;
          width: 34px;
          height: 34px;
          color: white;
          line-height: 34px;
          margin-bottom: 5px;
          & > img {
            width: 34px;
            height: 34px;
          }
        }
      }
    }
  }
  & > .verify-info {
    & > .bottom-check {
      & > .check-content {
        background-color: #fff;
        border: 1px solid #EEEEEE;
        margin: 0 auto;
        border-radius: 6px;
        padding: 6px 0 1px;
        overflow: hidden;
        & > .line {
          display: flex;
          padding: 3px 10px;
          border-bottom: 1px solid #eeeeee;
          height: 38px;
          &:last-child {
            border-bottom: none;
          }
          & > .line-cell {
            width: 50%;
            display: flex;
            align-items: center;
            & > .line-cell-name {
              color: #666666;
              font-size: 14px;
              width: 96px;
              flex-shrink: 0;
              font-weight: 550;
            }
            & > .line-cell-value {
              color: #333333;
              font-size: 14px;
              & > .el-input {
                width: 180px;
                height: 30px;
                & > .el-input__inner {
                  height: 30px;
                  border-radius: 5px;
                  border: 1px solid #f0f0fb;
                  background-color: #fff;
                }
              }
              & > .el-date-picker {
                width: 100%;
                height: 30px;
                & > .el-input__inner {
                  height: 30px;
                  border-radius: 5px;
                  border: 1px solid #f0f0fb;
                  background-color: #fff;
                }
              }
            }
          }
          & > .is-pass {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 8px;
            & > .el-icon-check {
              color: green;
              font-size: 18px;
            }
            & > .el-icon-close {
              color: red;
              font-size: 18px;
            }
          }
        }
      }
      & > .pass {
        width: 100%;
        display: flex;
        justify-content: center;
        & > .el-button {
          margin-top: 8px;
          background: #0D59A6;
          color: white;
          padding: 8px 30px;
          border-radius: 5px;
        }
      }
    }
  }
}
</style>
